import { FC, Fragment, lazy, Suspense, useEffect } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Outlet,
  Route,
  RouterProvider,
  Routes,
} from "react-router-dom";

import { EUserType } from "../environment";
import SuspenseLoader from "../components/Loader/SuspenseLoader";
import useAppLevelStores from "../stores/useAppLevelStores";
import useUserDataStore from "../stores/useUserDataStore";
import useDomainStore from "../stores/useDomainStores";
import useDomainService from "../services/useDomainService";
import useQuestionsService from "../services/useQuestionsService";
import useUserDataService from "../services/useUserDataService";

//   ***********************  Application Layout ***************************************
type ApplicationLayoutProps = {};
const ApplicationLayout: FC<ApplicationLayoutProps> = (): JSX.Element => {
  const appLevelContext = useAppLevelStores();

  return (
    <Fragment>
      {/* <PageLoader loading={appLevelContext.isLoading} /> */}
      <SuspenseLoader loading={appLevelContext.isLoading} />
      {/* <SuspenseLoader loading={true} /> */}
      <Outlet />
    </Fragment>
  );
};

//  ********************  suspence layout **************************
type SuspenseLayoutProps = {};
const SuspenseLayout: FC<SuspenseLayoutProps> = (): JSX.Element => (
  <Suspense fallback={<SuspenseLoader loading />}>
    <Outlet />
  </Suspense>
);

//   *************************  Routing Setup  ********************************** //
type MainRoutesProps = {};
const MainRoutes: FC<MainRoutesProps> = (): JSX.Element => {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route element={<ApplicationLayout />}>
        <Route element={<SuspenseLayout />}>
          <Route path="/*" element={<RouteContainer />} />
        </Route>
      </Route>
    )
  );
  return <RouterProvider router={router} />;
};

//   *************************************  Routing Container  ********************************** //

type RouteContainerProps = {};
const RouteContainer: FC<RouteContainerProps> = (): JSX.Element => {
  const usercontext = useUserDataStore();
  const userService = useUserDataService();
  const domainService = useDomainService();
  const questionService = useQuestionsService();
  
  useEffect(() => {
    if (usercontext.token) {
      domainService.initDomain();
      userService.initUserDetails();
      userService.initUserDetails();
      questionService.initQuestionsService();
      // userService.initUserService();
    }
  }, [usercontext.token]);

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Routes>
        {!usercontext.token && !usercontext.userdetails ? (
          <Fragment>
            <Route path="/" element={<HomePage />} />
            <Route path="/admin" element={<AuthAdminLogin />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Fragment>
        ) : usercontext.token &&
          usercontext.userdetails &&
          usercontext.userdetails.userType &&
          [
            EUserType.CENTRALADMIN,
            EUserType.CUSTADMIN,
            EUserType.CUSTMONADMIN,
            EUserType.LOCALSERVERADMIN,
            EUserType.MONADMIN,
          ].includes(usercontext.userdetails.userType) ? (
          <Fragment>
            <Route path="/admin/*" element={<AdminRelatedRoutes />} />
            <Route path="/" element={<Navigate to="/admin/*" />} />
            <Route path="*" element={<Navigate to="/admin/*" />} />
          </Fragment>
        ) : (
          <Fragment>
            <Route path="/" element={<HomePage />} />
            <Route path="/admin" element={<AuthAdminLogin />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Fragment>
        )}
      </Routes>
    </LocalizationProvider>
  );
};

const HomePage = lazy(() => import("../views/HomePage"));
const AdminRelatedRoutes = lazy(() => import("./AdminPortalRelatedRoutes"));
const AuthAdminLogin = lazy(
  () => import("../views/Authenticator/AuthAdminLogin")
);

export default MainRoutes;
